import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button } from "@mui/material";

export default function EposProductTableRow({
    BookerProductBarCode,
    product,
    bookerBarcode,
    handleModelAlert
}) {
    console.log(BookerProductBarCode == product.barcode)
    const eposUrl = `https://www.eposnowhq.com/products/${product.eposId}/edit`

    const copyToClip = (element) => {
        navigator.clipboard.writeText(element);
        handleModelAlert("COPIED TO CLIP BOARD", "success")
    };
    const checkBarcodeColour = ()=>{

    }


    return (
        <tr style={BookerProductBarCode && BookerProductBarCode.length> 0 && BookerProductBarCode.includes(product.barcode)?
            { borderLeft:'2px solid #f56262', borderWidth:6}
            :
            {borderLeft:'2px solid #70ffa7', borderWidth:4}
             }>
            <td
            style={{ fontWeight:300, padding:'0.5rem 0.2rem'  }}
                onClick={() => copyToClip(product.prodName)}
            >
                {product.prodName}
            </td>
            <td
                onClick={() => copyToClip(product.barcode)}
                style={{ fontWeight:500,   }}
            >
                {/* {product?.barcode?.includes(",") ? `${product.barcode.split(",").at(0)}...` : product.barcode} */}
             {product.barcode}
            </td>
            <td
                onClick={() => copyToClip(product.orderCode)}
            >
                {product.orderCode}
            </td>
            <td
                onClick={() => copyToClip(product.catName)}
            >
                {product.catName == "" || product.catName == null ? "Top Level" : product.catName}
            </td>
            <td
                onClick={() => copyToClip(product.salePrice)}
            >
                {product?.salePrice?.includes("£") ? product.salePrice : `£${product.salePrice}`}
            </td>

            <td>
                <Button
                size='small'
                    variant="contained"
                    color="primary"
                    href={eposUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                    Product 
                </Button>
            </td>
        </tr>
    )

}